<template>
  <div
    class="w-full relative h-10 border border-solid rounded-lg flex flex-wrap items-center"
    :class="{
      'text-white border-grey-700 bg-grey-800': hasState('dark'),
      'text-grey-600 border-grey-200 bg-white': !hasState('dark'),
      'mb-3': error
    }"
  >
    <slot name="prependIcon"></slot>
    <input
      :type="type"
      ref="input"
      v-bind="$attrs"
      :placeholder="placeholder"
      :value="value"
      :readonly="readonly"
      class="w-full h-full outline-none rounded-lg px-4"
      :class="{
        'bg-grey-800': hasState('dark'),
        'bg-white': !hasState('dark')
      }"
      @keydown="keydown"
      @keyup="keyup"
      @paste="paste"
      @focus="inputFocussed"
    />

    <span class="text-pink-dark text-sm" v-show="error">{{ error }}</span>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import mixins from '../mixins';

export default {
  name: 'TextInput',
  inheritAttrs: false,
  mixins: [mixins],
  props: {
    value: {},
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {},
    dark: {},
    readonly: {
      type: Boolean,
      default: false
    },
    selectAll: {
      type: Boolean,
      default: false
    },
    shouldValidateURL: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      error: null
    };
  },
  methods: {
    validate(value) {
      if (this.shouldValidateURL) {
        const patternURL = new RegExp(
          '^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?'+ // Port
          '(\\/[\\[\\]\\(\\)-a-z\\d%_.~#!+]*)*' + // Or path
          '(\\?[\\[\\]\\(\\);&a-z\\d%_.~+=-]*)?' + // Query string
          '(\\#[\\[\\]\\(\\)-a-z\\d_.]*)?$', // Hash
          'i'
        );

        const patternPhone = new RegExp(
          '^(tel?:)?'+
          '[\\+0-9]{1,15}$'
        );

        const patternMail = new RegExp(
          '^(mailto?:)?'+'[a-z0-9]+@[a-z]+\.[a-z]{2,3}$' // protocol
        );

        const patternHash = new RegExp(
          '#[a-z0-9_-]{2,}$' // protocol
        );

        this.error =
          patternURL.test(value) ||
          patternPhone.test(value) ||
          patternMail.test(value) ||
          patternHash.test(value)
            ? null
            : 'Not a valid URL!';
      }
    },
    keyup: debounce(function(e) {
      if (e.keyCode === 17 || e.ctrlKey) return;
      const { value } = this.$refs.input;
      this.validate(value);
      this.$emit('input', value);
      this.$emit('keyup', value);
    }, 50),
    keydown: debounce(function(e) {
      this.$emit('keydown', e);
    }, 50),
    paste(e) {
      setTimeout(() => {
        const { value } = e.target;
        this.validate(value);
        this.$emit('input', value);
        this.$emit('keyup', value);
      }, 0);
    },
    inputFocussed(e) {
      if (this.selectAll) {
        e.target.select();
      }
    }
  }
};
</script>
